/**
 * Grill King video gallery — poster facade + on-site lightbox.
 * Desktop: matched left/right rails; detail lines emerge from the video.
 */
(function () {
  var FALLBACK_DETAILS = [
    'Built for Australian outdoor living',
    'Premium finishes and stone cabinetry',
    'Showroom ready — NSW & VIC',
    'Warehouse pricing on complete kitchens'
  ];

  function parseDetails(raw, caption) {
    var lines = String(raw || '')
      .split(/[\r\n|]+/)
      .map(function (line) {
        return line.replace(/^\s*[-•]\s*/, '').trim();
      })
      .filter(Boolean);

    if (!lines.length && caption) lines.push(caption);
    if (!lines.length) lines = FALLBACK_DETAILS.slice();

    var seen = {};
    return lines.filter(function (line) {
      var key = line.toLowerCase();
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function initGallery(root) {
    if (!root || root.dataset.egjVideoReady === '1') return;
    root.dataset.egjVideoReady = '1';

    var dialog = root.querySelector('[data-egj-video-dialog]');
    var frame = root.querySelector('[data-egj-video-frame]');
    if (!dialog || !frame) return;

    if (dialog.parentElement !== document.body) {
      document.body.appendChild(dialog);
    }

    var asideLeft = dialog.querySelector('[data-egj-video-aside-left]');
    var asideRight = dialog.querySelector('[data-egj-video-aside-right]');
    var asideTitle = dialog.querySelector('[data-egj-video-aside-title]');
    var asideCaption = dialog.querySelector('[data-egj-video-aside-caption]');
    var detailsLeft = dialog.querySelector('[data-egj-video-aside-details-left]');
    var detailsRight = dialog.querySelector('[data-egj-video-aside-details-right]');
    var lastFocus = null;
    var pendingTrigger = null;
    var soundPrompt = dialog.querySelector('[data-egj-video-sound]');
    var revealTimer = null;
    var detailTimer = null;
    var detailQueue = [];
    var detailIndex = 0;

    function stopDetailReveal() {
      if (detailTimer) {
        clearInterval(detailTimer);
        detailTimer = null;
      }
      detailIndex = 0;
      detailQueue = [];
    }

    function clearAsides() {
      if (revealTimer) {
        clearTimeout(revealTimer);
        revealTimer = null;
      }
      stopDetailReveal();
      dialog.classList.remove('is-aside-in');
      if (asideTitle) asideTitle.textContent = '';
      if (asideCaption) asideCaption.textContent = '';
      if (detailsLeft) detailsLeft.innerHTML = '';
      if (detailsRight) detailsRight.innerHTML = '';
      if (asideLeft) asideLeft.setAttribute('aria-hidden', 'true');
      if (asideRight) asideRight.setAttribute('aria-hidden', 'true');
    }

    function appendDetail(target, text, fromRight) {
      if (!target || !text) return;
      var li = document.createElement('li');
      li.className = 'egj-video-gallery__aside-detail' + (fromRight ? ' egj-video-gallery__aside-detail--right' : '');
      li.textContent = text;
      target.appendChild(li);
      void li.offsetWidth;
      li.classList.add('is-in');
    }

    function startDetailReveal(lines, media) {
      stopDetailReveal();
      if (!lines.length) return;

      if (detailsLeft) detailsLeft.innerHTML = '';
      if (detailsRight) detailsRight.innerHTML = '';

      // Alternate left / right so both rails fill the same way
      detailQueue = lines.map(function (text, i) {
        return { text: text, right: i % 2 === 1 };
      });

      function revealNext() {
        if (dialog.hidden || detailIndex >= detailQueue.length) {
          stopDetailReveal();
          return;
        }
        var item = detailQueue[detailIndex];
        appendDetail(item.right ? detailsRight : detailsLeft, item.text, item.right);
        detailIndex += 1;
        if (detailIndex >= detailQueue.length) stopDetailReveal();
      }

      revealNext();
      if (detailIndex >= detailQueue.length) return;

      var duration = 55;
      if (media && media.tagName === 'VIDEO' && isFinite(media.duration) && media.duration > 0) {
        duration = media.duration;
      }
      var stepMs = Math.max(3500, Math.min(8000, Math.floor((duration * 1000) / Math.max(lines.length, 1))));

      detailTimer = setInterval(revealNext, stepMs);
    }

    function showSoundPrompt(show) {
      if (!soundPrompt) return;
      soundPrompt.hidden = !show;
    }

    function applySound(media, quiet) {
      if (media.tagName === 'IFRAME') {
        var src = media.getAttribute('src') || '';
        src = src.replace(/([?&])(mute|muted)=\d+/g, '$1').replace(/[?&]$/, '');
        if (quiet) {
          var flag = src.indexOf('vimeo.com') !== -1 ? 'muted=1' : 'mute=1';
          src += (src.indexOf('?') === -1 ? '?' : '&') + flag;
        }
        media.setAttribute('src', src);
        return;
      }
      if (media.tagName === 'VIDEO') {
        media.muted = quiet;
        if (quiet) media.setAttribute('muted', '');
        else media.removeAttribute('muted');
      }
    }

    function closeDialog() {
      dialog.hidden = true;
      document.documentElement.classList.remove('egj-video-gallery-open');
      frame.innerHTML = '';
      pendingTrigger = null;
      showSoundPrompt(false);
      clearAsides();
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      lastFocus = null;
    }

    function startPlayback(trigger, quiet) {
      var card = trigger.closest('.egj-video-card');
      var source = card && card.querySelector('[data-egj-video-source]');
      if (!source) return;
      var node = source.content.firstElementChild;
      if (!node) return;

      frame.innerHTML = '';
      var media = node.cloneNode(true);
      if (media.tagName === 'IFRAME') {
        media.removeAttribute('height');
        media.removeAttribute('width');
        media.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0;';
      }
      applySound(media, quiet);
      frame.appendChild(media);
      showSoundPrompt(false);

      if (media.tagName === 'VIDEO') {
        var playAttempt = media.play();
        if (playAttempt && typeof playAttempt.catch === 'function') playAttempt.catch(function () {});
      }

      var title = trigger.getAttribute('data-egj-video-title') || '';
      var caption = trigger.getAttribute('data-egj-video-caption') || '';
      var details = parseDetails(trigger.getAttribute('data-egj-video-details'), caption);

      if (caption) {
        details = details.filter(function (line) {
          return line.toLowerCase() !== caption.toLowerCase();
        });
      }

      if (asideTitle) asideTitle.textContent = title;
      if (asideCaption) asideCaption.textContent = caption || 'Outdoor kitchen details';
      if (asideLeft) asideLeft.setAttribute('aria-hidden', title ? 'false' : 'true');
      if (asideRight) asideRight.setAttribute('aria-hidden', 'false');
      dialog.classList.remove('is-aside-in');

      revealTimer = setTimeout(function () {
        dialog.classList.add('is-aside-in');
        revealTimer = null;
        startDetailReveal(details, media);
      }, 280);
    }

    function openDialog(trigger) {
      var card = trigger.closest('.egj-video-card');
      var source = card && card.querySelector('[data-egj-video-source]');
      if (!source) return;

      lastFocus = document.activeElement;
      pendingTrigger = trigger;
      frame.innerHTML = '';
      clearAsides();
      dialog.classList.remove('is-aside-in');
      dialog.hidden = false;
      document.documentElement.classList.add('egj-video-gallery-open');
      showSoundPrompt(true);

      var quietBtn = soundPrompt && soundPrompt.querySelector('[data-egj-video-sound-choice="quiet"]');
      if (quietBtn) quietBtn.focus();
    }

    root.querySelectorAll('[data-egj-video-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openDialog(btn);
      });
    });

    if (soundPrompt) {
      soundPrompt.querySelectorAll('[data-egj-video-sound-choice]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!pendingTrigger) return;
          startPlayback(pendingTrigger, btn.getAttribute('data-egj-video-sound-choice') === 'quiet');
        });
      });
    }

    dialog.querySelectorAll('[data-egj-video-close]').forEach(function (el) {
      el.addEventListener('click', closeDialog);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !dialog.hidden) closeDialog();
    });
  }

  function boot() {
    document.querySelectorAll('[data-egj-video-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section) return;
    section.querySelectorAll('[data-egj-video-gallery]').forEach(function (root) {
      root.dataset.egjVideoReady = '';
      initGallery(root);
    });
  });
})();
